import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Executive from '../pages/Executive';

/**
 * RoleBasedDashboard - Redirects users to their role-specific dashboard
 * Based on RBAC permissions matrix default_dashboard
 */
const RoleBasedDashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const roleDefaultDashboards = {
    'super_admin': '/', // Executive Dashboard
    'program_admin': '/programs',
    'noc_operator': '/network',
    'fleet_manager': '/fleet-apis',
    'finance_viewer': '/revenue',
    'gov_viewer': '/gov/planner',
    'internal': '/',
    'guest': '/'
  };

  useEffect(() => {
    if (user && user.role) {
      const defaultDashboard = roleDefaultDashboards[user.role] || '/';
      
      // If we're at root and user has a different default, redirect
      if (window.location.pathname === '/' && defaultDashboard !== '/') {
        navigate(defaultDashboard);
      }
    }
  }, [user, navigate]);

  // Default to Executive Dashboard if no redirect needed
  return <Executive />;
};

export default RoleBasedDashboard;
